import React from "react";
import { History } from "lucide-react";
import { useApi } from "@/lib/useApi";
import { useT } from "@/lib/i18n";
import { Card, EmptyState, ErrorState, ListSkeleton, PageTitle } from "@/components/common";
import { BackLink } from "@/pages/More";

export default function AuditLog() {
  const { t, lang } = useT();
  const { data, loading, error, reload } = useApi<any[]>("/audit?limit=200");
  return (
    <div>
      <BackLink />
      <PageTitle title={t("audit_log")} />
      {loading && !data ? <ListSkeleton /> : error ? <ErrorState message={error} onRetry={reload} /> : !data.length ? (
        <EmptyState testId="audit-empty" icon={History} title={t("no_activity")} />
      ) : (
        <Card className="divide-y divide-slate-100" data-testid="audit-list">
          {data.map((a) => (
            <div key={a.id} className="p-3.5 text-sm flex justify-between gap-3">
              <div className="min-w-0">
                <p className="font-semibold font-mono-num text-xs text-emerald-800">{a.action}</p>
                {a.meta && Object.keys(a.meta).length > 0 && <p className="text-xs text-slate-500 truncate">{Object.entries(a.meta).map(([k, v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`).join(" · ")}</p>}
              </div>
              <span className="text-xs text-slate-400 shrink-0">{new Date(a.at).toLocaleString(lang === "hi" ? "hi-IN" : "en-IN", { dateStyle: "short", timeStyle: "short" })}</span>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
